<template lang="pug">
    Aside(:ativo="ativo", @close="$emit('close')")#aside
        h2 Aluno UniFAEL já tem acesso no Portal do Aluno.
        a(href="https://portaldoaluno.fael.edu.br/users/sign_in", target="_blank", title="Ir para o Portal do Aluno").link ME LEVE PARA LÁ
</template>

<script>
import Aside from '@components/Aside/Aside'

export default {
    name: "section-aside",
    components: {
        Aside
    },
    props: {
        ativo: Boolean
    }
}
</script>

<style lang="stylus" scoped src="./Aside.styl"></style>
